import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Dashboard from './pages/Dashboard';
import Home from './pages/Home';
import ResultList from './pages/ResultsList';
import ComparePage from './pages/ComparePage';

import PublicRoute from './components/PublicRoute';
import PrivateRoute from './components/PrivateRoute';
import Signup from './components/Signup';

import ClusterView from './pages/ClusterView';




function App() {
  
  return (
    <BrowserRouter>
      <Routes>

        {/* Page Home = page de login => public */}
        <Route 
          path="/" 
          element={
            <PublicRoute>
              <Home />
            </PublicRoute>
          }
        />

        {/* Inscription => public */}
        <Route 
          path="/signup" 
          element={
            <PublicRoute>
              <Signup />
            </PublicRoute>
          }
        />

        {/* Dashboard => privé */}
        <Route 
          path="/dashboard" 
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        {/* Compare => privé */}
        <Route
          path="/compare"
          element={
            <PrivateRoute>
              <ComparePage />
            </PrivateRoute>
          }
        />

        {/* Results => privé */}
        <Route
          path="/results"
          element={
            <PrivateRoute>
              <ResultList />
            </PrivateRoute>
          }
        />

        {/* Cluster View => privé */}
        <Route
          path="/cluster"
          element={
            <PrivateRoute>
              <ClusterView />
            </PrivateRoute>
          }
        />
        
      </Routes>
    </BrowserRouter>
  );
}


export default App;
